import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, Theme } from '@/utils/constants';

const lightTheme = {
  root: {
    '& $superheading': {
      color: SecondaryColors.dark,
    },
  },
};
const darkTheme = {
  root: {
    '& $superheading': {
      color: SecondaryColors.main,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
    },
    superheading: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(2),
      },
    },
  }),
  { name: 'GenPressCenterResource' },
);

export default useStyles;
